import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SessionService } from './session.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class IdleService {
  timer = 0;
  interval: any;
  showIdleModalSubject = new BehaviorSubject(false);
  showIdleModal$ = this.showIdleModalSubject.asObservable();
  constructor(private router: Router, private session: SessionService) {
    this.addListners();
  }

  addListners() {
    let root: any = document.querySelector('html');
    window.addEventListener('load', this.resetTimer.bind(this));
    window.addEventListener('mousemove', this.resetTimer.bind(this));
    window.addEventListener('click', this.resetTimer.bind(this));
    window.addEventListener('keypress', this.resetTimer.bind(this));
    window.addEventListener('resize', this.resetTimer.bind(this));
    let observer = new MutationObserver(this.resetTimer.bind(this));
    observer.observe(root, { attributes: true, childList: true });
  }

  startTimer(time = 60) {
    clearInterval(this.interval);
    this.interval = setInterval(() => {
      if (++this.timer == time) {
        let token = sessionStorage.getItem('token');
        if (token) {
          this.showIdleModal(time);
        } else {
          this.timer = 0;
        }
      }
    }, 1000);
  }

  resetTimer() {
    this.timer = 0;
    this.showIdleModalSubject.next(false);
  }

  showIdleModal(expiryTime: number) {
    this.timer = expiryTime - 30;
    let shown = this.showIdleModalSubject.getValue();
    if (shown) {
      this.signOut();
    } else this.showIdleModalSubject.next(true);
  }

  signOut() {
    let token : any = sessionStorage.getItem('token');
    sessionStorage.clear();
    (window as any).exitWebView();
    this.session.token = '';
    this.showIdleModalSubject.next(false);
    this.router.navigate(['landing'], { state : { timeout : true , token : token }});
  }
}
